import Vue from "vue";
import { GlobalStore } from "../globalStore";
import { GlobalMethods } from "../globalMethods";
import { appFunctions } from "../helpers/appFunctions";

export const templateMethods = new Vue({
  methods: {
    /**
     * Applies ##merge.field## replacements and accept-quote shortcut.
     * Used by populateEmailTemplate and test-email flows that pass raw HTML/subject.
     */
    applyMergeFieldsToTemplate(subjectLine, templateContent, dataFields) {
      let outContent =
        templateContent != null ? String(templateContent) : "";
      let outSubject = subjectLine != null ? String(subjectLine) : "";

      if (dataFields && dataFields.length) {
        dataFields.forEach(field => {
          outContent = GlobalMethods.replaceAll(
            outContent,
            "##" + field.key + "##",
            field.value
          );
          outSubject = GlobalMethods.replaceAll(
            outSubject,
            "##" + field.key + "##",
            field.value
          );
        });
      }

      const guid =
        dataFields && dataFields.find(k => k.key == "policy.customer-policy-guid");

      if (guid) {
        var acceptQuoteLink =
          "<a href='" +
          process.env.VUE_APP_SITEURL +
          "/acceptOffer/" +
          guid.value +
          "'>Click here to accept quote</a>";

        outContent = outContent
          .toString()
          .replace("##Click here to accept quote##", acceptQuoteLink);
      }

      return { subjectLine: outSubject, templateContent: outContent };
    },

    async populateEmailTemplate(realmApp, dataFields, emailTemplateId) {
      var resp = await appFunctions.crud_emailTemplate("get", {
        email_template_id: emailTemplateId
      });

      var templateContent = resp.data.email_template_html;
      var subjectLine = resp.data.email_template_subject_line;

      console.log(dataFields);

      const merged = this.applyMergeFieldsToTemplate(
        subjectLine,
        templateContent,
        dataFields
      );

      console.log(dataFields);

      return {
        subjectLine: merged.subjectLine,
        templateContent: merged.templateContent
      };
    },
    async populateContentTemplate(realmApp, dataFields, contentTemplateId) {
      var resp = await appFunctions.crud_contentTemplate("get", {
        content_template_id: contentTemplateId
      });

      var templateContent = resp.data.content_template_html;
      //var subjectLine = resp.data.content_template_subject_line;

      console.log(templateContent);

      dataFields.forEach(field => {
        templateContent = GlobalMethods.replaceAll(
          templateContent,
          "##" + field.key + "##",
          field.value
        );
      });

      //console.log(dataFields);

      //var guid = dataFields.find(k => k.key=="policy.customer-policy-guid").value;

      // var acceptQuoteLink = "<a href='" +
      // GlobalStore.siteURL +
      // "/acceptOffer/" + guid
      // +"'>Click here to accept quote</a>";

      //console.log(acceptQuoteLink);

      // templateContent = templateContent
      //   .toString()
      //   .replace(
      //     "##Click here to accept quote##",
      //     acceptQuoteLink
      //   );

      // templateContent = GlobalMethods.replaceAll(
      //   templateContent,
      //   "##Click here to set your password##",
      //   "<a href='#'>Click here to set your password</a>"
      // );

      return { templateContent };
    },
    convertToHashFields(dataObject, keyName) {
      if (!dataObject || typeof dataObject !== "object") {
        return [];
      }
      const fields = Object.keys(dataObject);
      var retArray = [];

      fields.forEach((key, index) => {
        // console.log(`${key}: ${dataObject[key]}`);
        if (key !== "_id") {
          var tFieldName = GlobalMethods.replaceAll(
            key,
            "_",
            "-"
          ).toLowerCase();
          retArray.push({
            key: keyName + "." + tFieldName,
            value: dataObject[key]
          });
        }
      });
      return retArray;
    },
    convertToHashFieldsNoLower(dataObject, keyName) {
      const fields = Object.keys(dataObject);
      var retArray = [];

      fields.forEach((key, index) => {
        // console.log(`${key}: ${dataObject[key]}`);
        if (key !== "_id") {
          var tFieldName = GlobalMethods.replaceAll(key, "_", "-");
          retArray.push({
            key: keyName + "." + tFieldName,
            value: dataObject[key]
          });
        }
      });
      return retArray;
    }
  }
});
